<template>
  <div>
    <v-row
      align="center"
      justify="center"
    >
      <v-col>
        <VTextField
          v-model="name[selectedLang]"
          :label="$t('forms.labels.name')"
          outlined
          :rules="{ required: selectedLang === teamMainLang, min: 1, max: 200 }"
          data-cy="container-name-text"
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';

export default {
    components: {
        VTextField,
    },
    props: {
        containerType: {
            type: Object,
            default: () => ({}),
        },
        isEdition: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            name: {},
        };
    },
    computed: {
        ...mapGetters([
            'userLang',
            'teamLangs',
            'teamMainLang',
            'selectedLang',
        ]),
    },
    watch: {
        data: {
            handler() {
                this.$emit('sendData', this.name);
            },
            deep: true,
        },
    },
    async created() {
        if (this.isEdition) {
            this.name = this.containerType.name;
        }
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.name);
        },
    },
};
</script>
